/* eslint-disable react-hooks/exhaustive-deps */
import { consumirServicioEncirptacion } from 'api';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDown } from 'components/InputsMex/inputs';
import {
  SimpleDropDownDateInputField,
  SimpleDropDownInputField,
  SimpleTextInputField,
} from 'components/InputsMex/SimpleInputs';
import { required } from 'components/InputsMex/validaciones';
import { urlCertificadosCrear } from 'constants/urls';
import useCustomToast from 'hooks/useCustomToasts';
import useUsuario from 'hooks/useUsuario';
import moment from 'moment';
import React, { useMemo } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import useDetallePoliza from 'redux/hooks/useDetallePoliza';
import FormBeneficiariosCertificadoPoliza from './FormBeneficiariosCertificadoPoliza';

const PORCENTAJES = {
  MINIMO: 100,
  MAXIMO: 100,
};
const todayMoment = moment();
const tomorrowMoment = moment().add(1, 'days');

const FormCertificadoPoliza = () => {
  const methods = useForm({
    mode: 'onChange',
  });

  const { addWarningToast, addSuccessToast } = useCustomToast();

  const {
    setShowForm,
    certificadosProps,
    setLoading,
    setCertificadosProps,
    setStateDetallePoliza,
  } = useDetallePoliza();

  const usuario = useUsuario();

  const { sources, rules, validaciones } = useMemo(
    () => ({
      ...certificadosProps,
      rules: {
        cliIdentificacion: { validate: required() },
        cliNombres: { validate: required() },
        cliApellidos: { validate: required() },
        cargo: { validate: required() },
        genero: { required: 'Campo obligatorio' },
        fechaNac: { required: 'Campo obligatorio' },
        destino: { required: 'Campo obligatorio' },
        cliEmail: { required: 'Campo obligatorio' },
        iniVigencia: {
          validate: (value) => {
            if (!value) {
              return 'Campo obligatorio';
            }
            const fin = methods.getValues('finVigencia');

            if (!fin) {
              methods.setError('finVigencia', {
                type: 'sinFin',
                message: 'Seleccione una fecha de fin de vigencia',
              });
              return true;
            }

            const valueMoment = moment(value, 'yyyy-MM-DD');
            const finMoment = moment(fin, 'yyyy-MM-DD');

            if (valueMoment.isSame(finMoment)) {
              return 'La fecha de inicio no puede ser igual a la fecha de fin de vigencia';
            }

            if (valueMoment.isAfter(finMoment)) {
              return 'La fecha de incio no puede ser superior a la fecha de fin de vigencia';
            }

            if (finMoment.isBefore(valueMoment)) {
              return 'La fecha de fin no puede ser anterior a la fecha de inicio de vigencia';
            }

            if (valueMoment.isBefore(todayMoment)) {
              return 'La fecha ingresada no puede ser menor a la de hoy';
            }

            if (finMoment.diff(valueMoment, 'days') > validaciones.diasMaximos) {
              return `Periodo máximo de ${validaciones.diasMaximos} días continuos de viaje`;
            }
            methods.clearErrors('finVigencia');

            return true;
          },
        },
        finVigencia: {
          validate: (value) => {
            if (!value) {
              return 'Campo obligatorio';
            }
            const inicio = methods.getValues('iniVigencia');
            if (!inicio) {
              methods.setError('iniVigencia', {
                type: 'sinFin',
                message: 'Seleccione una fecha de fin de vigencia',
              });
              return true;
            }
            const valueMoment = moment(value, 'yyyy-MM-DD');
            const inicioMoment = moment(inicio, 'yyyy-MM-DD');

            if (inicioMoment.isSame(valueMoment)) {
              return 'La fecha de inicio no puede ser igual a la fecha de fin de vigencia';
            }

            if (inicioMoment.isAfter(valueMoment)) {
              return 'La fecha de incio no puede ser superior a la fecha de fin de vigencia';
            }

            if (valueMoment.isBefore(inicioMoment)) {
              return 'La fecha de fin no puede ser anterior a la fecha de inicio de vigencia';
            }

            if (valueMoment.diff(inicioMoment, 'days') > validaciones.diasMaximos) {
              return `Periodo máximo de ${validaciones.diasMaximos} días continuos de viaje`;
            }
            methods.clearErrors('iniVigencia');
            return true;
          },
        },
      },
    }),
    [certificadosProps],
  );

  const { idPoliza, codPlan } = useParams();

  const { getValues } = methods;

  const sumarPorcentaje = () => {
    const values = getValues('listBeneficiarios');
    try {
      return values
        ?.map((item) => Number(item.porcentaje))
        ?.reduce((val1, val2) => val1 + val2);
    } catch (error) {
      return 0;
    }
  };

  const onSubmit = async (data) => {
    const Data = {
      ...data,
      idPoliza,
      codPlan,
      codigoDestino: data?.destino.value,
      nomDestino: data?.destino.label,
    };
    Data.nomUsuario = usuario.fullName;
    Data.codusuario = usuario.cliCodigoCore;
    console.log('DATA: ', data);
    setLoading(true);
    const res = await consumirServicioEncirptacion(urlCertificadosCrear, Data);
    console.log('RES: ', res);
    if (res?.transaccion) {
      setCertificadosProps(res);
      setStateDetallePoliza(res?.poliza);
      setShowForm(false);
      addSuccessToast('Se ha creado un nuevo certificado');
    } else {
      res.errorDescripcion.forEach(addWarningToast);
      methods.reset(data);
    }

    setLoading(false);
  };

  const onSubmitError = () => {
    addWarningToast('Por favor rellene el formulario correctamente');
  };

  console.log(validaciones);

  return (
    <React.Fragment>
      <div className="col-12 row justify-content-center">
        <div className="col-11 col-lg-10">
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit, onSubmitError)}>
              <h4 className="my-1">
                * Por favor ingrese la siguiente informacion del pasajero
              </h4>
              <div className="row justify-content-center">
                <div className="col-12 col-md-11 col-lg-10 ">
                  <div className="login__card__title">
                    <div className="form-row justify-content-around">
                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleTextInputField
                          label="Pasaporte/Id/Numero de empleado"
                          name="cliIdentificacion"
                          rules={rules.cliIdentificacion}
                        />
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleContainer label="Género" name="genero">
                          <DropDown
                            name="genero"
                            options={sources?.generos}
                            rules={rules.genero}
                          />
                        </SimpleContainer>
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleTextInputField
                          label="Nombres"
                          name="cliNombres"
                          rules={rules.cliNombres}
                        />
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleTextInputField
                          label="Apellidos"
                          name="cliApellidos"
                          rules={rules.cliApellidos}
                        />
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleDropDownDateInputField
                          label="Fecha de nacimiento"
                          name="fechaNac"
                          minDate={validaciones?.fechaNacimiento?.maxima}
                          maxDate={validaciones?.fechaNacimiento?.minima}
                          rules={rules.fechaNac}
                          helpText={`La edad mínima es de ${validaciones?.edad?.minima} y máxima de ${validaciones?.edad?.maxima} años`}
                        />
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleDropDownInputField
                          label="Destino"
                          name="destino"
                          options={sources?.paises}
                          rules={rules.destino}
                        />
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleDropDownDateInputField
                          label="Fecha inicio viaje"
                          name="iniVigencia"
                          minDate={new Date()}
                          rules={rules.iniVigencia}
                        />
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleDropDownDateInputField
                          label="Fecha fin viaje"
                          name="finVigencia"
                          minDate={tomorrowMoment.toDate()}
                          rules={rules.finVigencia}
                        />
                        <p className="font-14px">
                          Periodo máximo de 90 días continuos de viaje
                        </p>
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleTextInputField
                          label="Cargo"
                          name="cargo"
                          rules={rules.cargo}
                        />
                      </div>

                      <div className="form-group col-md-6 col-lg-5 ">
                        <SimpleTextInputField
                          label="Correo"
                          name="cliEmail"
                          rules={rules.cliEmail}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <Controller
                  control={methods.control}
                  name="listBeneficiarios"
                  defaultValue={[]}
                  rules={{
                    validate: (value = []) => {
                      if (value.length < validaciones.beneficiarios.minimo) {
                        return `Debe ingresar entre ${validaciones.beneficiarios.minimo} a ${validaciones.beneficiarios.maximo} de beneficiarios`;
                      }

                      if (value.length > 0) {
                        const porcentajeTotal = sumarPorcentaje();
                        if (porcentajeTotal !== PORCENTAJES.MINIMO) {
                          return `Debe completar mínimo el ${PORCENTAJES.MINIMO} de porcentaje entre todos los beneficiarios`;
                        }
                        return true;
                      }

                      return 'Debe ingresar mínimo un beneficiario';
                    },
                  }}
                  render={(props) => (
                    <FormBeneficiariosCertificadoPoliza
                      porcentajeTotal={sumarPorcentaje()}
                      PORCENTAJES={PORCENTAJES}
                      parentescos={sources?.parentescos}
                      validaciones={validaciones}
                      value={props.value}
                      onChange={props.onChange}
                    />
                  )}
                />
              </div>

              <div className="form-row justify-content-center">
                <div className="col-md-3 my-1">
                  <button
                    className="btn btn-atras-api"
                    type="button"
                    onClick={() => setShowForm(false)}
                  >
                    Cancelar
                  </button>
                </div>
                <div className="col-md-3 my-1">
                  <button className="btn btn-siguiente-api" type="submit">
                    Agregar
                  </button>
                </div>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormCertificadoPoliza;
